export default __webpack_public_path__ + "static/media/link.a0e2fdf8.svg";